import React from "react";
import { useSelector } from "react-redux";
import { selectMasterSpareFilter } from "../../../../store/master/masterSpareSlice";
import {
  selectMasterSpareList,
  useGetMasterSpareListQuery,
} from "../../../../services/master/masterSpareApiSlice";



import classes from "./masterSparesListPage.module.css";
import { MasterSparesFilterPage } from "../MasterSparesFilterPage";
import { MasterSpareTablePage } from "../masterSpareTable/MasterSpareTablePage";


export const MasterSparesListPage = () => {
  const { brand, model, spare } = useSelector(selectMasterSpareFilter);
  const { isLoading, isSuccess, error } = useGetMasterSpareListQuery({
    brand,
    model,
    spare,
  });

  const tableData = useSelector(selectMasterSpareList);

  return (
    <div className={classes.box}>
      <MasterSparesFilterPage />
      <MasterSpareTablePage data={tableData} />
    </div>
  );
};
